/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Confirm_Disabled_HintInputs */

const vi_await_confirm_disabled_hint = /** @type {(inputs: Await_Confirm_Disabled_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho vẫn còn thiếu hàng — chờ đội đóng gói bổ sung rồi bấm 'Kiểm tra đủ hàng' để refresh.`)
};

/**

* @param {Await_Confirm_Disabled_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_confirm_disabled_hint = /** @type {((inputs?: Await_Confirm_Disabled_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Confirm_Disabled_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_confirm_disabled_hint(inputs)
});